import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    
    try {
      await axios.post(`${API}/contact-messages`, formData);
      setSubmitted(true);
      toast.success("Besked sendt!");
    } catch (err) {
      console.error("Error sending contact form:", err);
      toast.error("Kunne ikke sende besked. Prøv igen.");
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen pt-20 pb-12 px-4 flex items-center justify-center" data-testid="contact-page">
        <div className="public-card p-8 text-center max-w-lg">
          <div className="w-20 h-20 bg-green-600/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <Check className="w-10 h-10 text-green-400" />
          </div>
          <h2 className="text-3xl font-['Oswald'] font-bold text-white mb-4">TAK FOR DIN BESKED</h2>
          <p className="text-gray-300 mb-6">
            Vi har modtaget din besked og vender tilbage snarest muligt.
            Du vil modtage en bekræftelse på email.
          </p>
          <Link to="/" className="chrome-btn px-6 py-3 rounded-lg inline-block" data-testid="contact-back-btn">
            Tilbage til forsiden
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-20 pb-12 px-4" data-testid="contact-page">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-4xl font-['Oswald'] font-bold chrome-text mb-2 text-center">KONTAKT OS</h1>
        <p className="text-gray-400 text-center mb-8">
          Har du spørgsmål? Skriv til os
        </p>

        <div className="public-card p-6 sm:p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-gray-300 mb-2 text-lg">Dit navn *</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="mc-input w-full"
                required
                placeholder="Skriv dit navn"
                data-testid="contact-name-input"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-2 text-lg">Email *</label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="mc-input w-full"
                required
                placeholder="din@email.dk"
                data-testid="contact-email-input"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-2 text-lg">Emne *</label>
              <input
                type="text"
                value={formData.subject}
                onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                className="mc-input w-full"
                required
                placeholder="Hvad handler din besked om?"
                data-testid="contact-subject-input"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-2 text-lg">Besked *</label>
              <textarea
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                className="mc-input w-full h-40 resize-none"
                required
                placeholder="Skriv din besked her..."
                data-testid="contact-message-input"
              />
            </div>

            <button
              type="submit"
              disabled={submitting}
              className="radial-btn w-full py-4 rounded-xl text-lg disabled:opacity-50"
              data-testid="submit-contact-btn"
            >
              {submitting ? <><span className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin inline-block mr-2" />Sender...</> : "Send besked"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
